interface ReplacePropsWithPreviewTypes {
    href?: string;
    onClick?: (MouseEvent?) => void;
    rel?: string;
}

export const replacePropsWithPreview = (normalProps: ReplacePropsWithPreviewTypes, isPreview: boolean): ReplacePropsWithPreviewTypes => {
    if (isPreview) {
        return {
            onClick: (e: MouseEvent) => {
                e.preventDefault();
                alert('Knapper og lenker er skrudd av under forhåndsvisning');
            },
        };
    }
    return normalProps;
};
